module.exports = __webpack_public_path__ + "media/svg/py-7f4d1c31.svg";